import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="tom-select"
export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.selectTargets.forEach((select) => {
      new TomSelect(select, {
        create: false,
        maxItems: null,
        closeAfterSelect: true,
        plugins: ["remove_button"],
        searchField: "text",
        render: {
          option: (data, escape) => `<div>${escape(data.text)}</div>`,
          item: (data, escape) => `<div>${escape(data.text)}</div>`,
        },
      });
    });
  }
}
